import React from 'react'
import { FormattedMessage } from 'react-intl'

import AdminActionButton from '../admin-action/AdminActionButton'
import { AdminActionEnum } from '../admin-action/utils/admin-action-data'
import PingPongButton from '../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../utils/ping-pong-button-type.enum.ts'
import { ClientProposalOutputDto } from '../../../../../../lib/graphql'
import { IProposalInteractionsProps } from '../../../Proposal'

interface IDepositPaidFooterProps {
  adminActions: IProposalInteractionsProps['adminActions']
  clientProposal: Pick<ClientProposalOutputDto, '_id' | 'permissions'>
}

const DepositPaidFooter = ({
  adminActions,
  clientProposal,
}: IDepositPaidFooterProps) => {
  const adminSkippedAdjustments = adminActions?.adminSkippedAdjustments

  return (
    <div className='flex w-full flex-col gap-3 py-5'>
      <PingPongButton
        dataTestId='paid-deposit-button'
        type={PingPongButtonTypeEnum.PAYMENT_DONE}
        label={
          <FormattedMessage
            id='ui.DepositPaidFooter.depositPaid'
            defaultMessage='Acompte réglé'
          />
        }
      />

      {adminSkippedAdjustments && (
        <AdminActionButton
          adminAction={AdminActionEnum.SKIP_ADJUSTMENTS}
          onClickConfirm={() =>
            adminSkippedAdjustments.callback({
              clientProposalId: clientProposal._id,
            })
          }
          isLoading={adminSkippedAdjustments.isLoading}
        />
      )}
    </div>
  )
}

export default DepositPaidFooter
